import { render, staticRenderFns } from "./HotelResultLoader.vue?vue&type=template&id=6ebb4efc"
import script from "./HotelResultLoader.vue?vue&type=script&lang=js"
export * from "./HotelResultLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports